
<app-loading
  [loading] = loading
></app-loading>

<div class="modal-overlay" *ngIf="modalDetalhes" (click)="!loading && fecharModal()">
  <div class="box-detalhe-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-10">
        <h5 class="fw-bold">
          <i class="fa fa-gavel"></i> Audiência
        </h5>
      </div>
      <div class="col-md-2 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <div class="col-md-12">
        <div class="row g-2">
          <div class="col-md-8" *ngIf="audiencia.processoId && audiencia.processoId > 0">
            <i class="fa fa-telegram me-1"></i> <b>Processo: </b><br>
            {{audiencia.processoNumero}} - {{audiencia.processo?.titulo}}
          </div>
          <div class="col-md-4">
            <i class="fa fa-map-marker me-1"></i> <b>Local: </b><br>
            {{audiencia.local}}
          </div>
          <div class="col-md-4">
            <i class="fa fa-calendar me-1"></i> <b>Data: </b><br>
            {{dataAudiencia | date: 'dd/MM/yyyy'}}
          </div>
          <div class="col-md-2">
            <i class="fa fa-clock-o me-1"></i> <b>Hora: </b><br>
            {{horaAudiencia}}
          </div>
          <div class="col-md-2">
            <i class="fa fa-flag me-1"></i> <b>Status: </b><br>
            {{ getStatusDescricao(audiencia.status) }}
          </div>
        </div>
      </div>

      <hr>

      <div class="col-md-8">
        <div class="mb-3">
          <label class="form-label fw-bold"><i class="fa fa-telegram me-1"></i> Processo</label>
          <ng-select [items]="listaProcessos"
                     bindLabel="numero"
                     bindValue="id"
                     [(ngModel)]="audiencia.processoId"
                     [clearable]="false"
                     placeholder="Selecione o processo"
                     (change)="botaoSalvarLocal = true">
            <ng-template ng-label-tmp let-item="item">
              {{item.numero}} - {{item.titulo}}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{item.numero}} - {{item.titulo}}
            </ng-template>
          </ng-select>
        </div>

        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label fw-bold"><i class="fa fa-map-marker me-1"></i> Local</label>
            <input (focus)="botaoSalvarLocal = true" [(ngModel)]="audiencia.local" type="text" class="form-control" placeholder="Local da audiência">
          </div>
          <div class="col-md-3">
            <label class="form-label fw-bold"><i class="fa fa-calendar me-1"></i> Data</label>
            <input (focus)="botaoSalvarLocal = true" [(ngModel)]="dataAudiencia" type="date" class="form-control">
          </div>
          <div class="col-md-3">
            <label class="form-label fw-bold"><i class="fa fa-clock-o me-1"></i> Hora</label>
            <input (focus)="botaoSalvarLocal = true" [(ngModel)]="horaAudiencia" type="time" class="form-control">
          </div>
        </div>

        <div *ngIf="botaoSalvarLocal" class="mt-3 d-flex gap-2">
          <button (click)="salvar()" class="btn btn-primary btn-sm" >Salvar</button>
          <button (click)="cancelar()" class="btn btn-light btn-sm" >Cancelar</button>
        </div>
      </div>

      <div class="col-md-4" *ngIf="podeExibirAcoes">
        <div class="card bg-light border-0">
          <div class="card-body">
            <h6 class="fw-bold mb-3">Ações</h6>
            <div class="d-grid gap-2">
              <button (click)="finalizarAudiencia()" class="btn btn-info btn-sm text-white">
                <i class="fa fa-check"></i> Finalizar
              </button>
              <button (click)="cancelarAudiencia()" class="btn btn-warning btn-sm">
                <i class="fa fa-times"></i> Cancelar
              </button>
              <button (click)="excluir()" class="btn btn-danger btn-sm" >
                <i class="fa fa-trash"></i> Excluir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
